import types from "../../../../Redux/ActionTypes/Index";

const setRequisitionData = (ReqObj) => {
  return {
    type: types.SET_REQUSITION_DATA,
    payload: ReqObj,
  };
};

const setSelectedRequisitionData = (reqObj)=>{
  return {
    type: types.SET_SELECTED_REQUSITION_DATA,
    payload: reqObj,
  };
}

// Diagnosis codes returned by the patient smart search are parked here until
// LoadReqSection/ByFacilityIDandInsuranceId resolves, since the Diagnosis /
// ICD-10 section does not exist yet when the patient is selected.
const setPendingDiagnosisCodes = (codes) => {
  return {
    type: types.SET_PENDING_DIAGNOSIS_CODES,
    payload: Array.isArray(codes) ? codes : [],
  };
};

export {
  setRequisitionData,
  setSelectedRequisitionData,
  setPendingDiagnosisCodes,
};